var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var queries_1 = require("./__generated__/queries");
var Line = function (props) { return react_2.default.createElement(react_1.Text, __assign({ as: "p", marginBottom: "1em" }, props)); };
var SoftwareInfo = function () {
    var _a = queries_1.useSoftwareQuery(), data = _a.data, error = _a.error, loading = _a.loading;
    if (error) {
        return react_2.default.createElement(react_1.Alert, { status: "error" }, error.message);
    }
    if (!data && loading) {
        return react_2.default.createElement(react_1.Alert, { status: "info" }, "Loading...");
    }
    return react_2.default.createElement(react_1.Box, { borderWidth: "1px", borderStyle: "solid", borderColor: "primary.100", maxWidth: "460px", margin: "0 auto", rounded: "md", padding: ".5em" },
        react_2.default.createElement(react_1.Heading, { as: "h3", textAlign: "center", size: "lg", mb: ".3em" }, "Software versions"),
        react_2.default.createElement(Line, null,
            "Player version: ",
            (data === null || data === void 0 ? void 0 : data.playerVersion) || "Unknown"),
        react_2.default.createElement(Line, null,
            "Playlist version: ",
            (data === null || data === void 0 ? void 0 : data.playlistVersion) || "Unknown"),
        react_2.default.createElement(Line, null,
            "Provider version: ",
            (data === null || data === void 0 ? void 0 : data.providerVersion) || "Unknown"));
};
exports.default = SoftwareInfo;
//# sourceMappingURL=SoftwareInfo.js.map